import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import autoBind from "react-autobind";

import * as modalActions from "../../actions/modalActions";
import * as userActions from "../../actions/userActions";
import * as accountActions from "../../actions/accountActions";
import * as chargetypeActions from "../../actions/chargetypeActions";
import * as contractActions from "../../actions/contractActions";
import * as divisionActions from "../../actions/divisionActions";
import * as invoiceActions from "../../actions/invoiceActions";
import * as itemActions from "../../actions/itemActions";

import InvoiceApprovalList from "./InvoiceApprovalList";
import InvoicePreview from "./invoiceLines/invoicePreview/InvoicePreview";
import BreadCrumbs from "../common/BreadCrumbs";
import Modal from "../common/Modal";
import Formsy from "formsy-react";
import Select from "react-select";

import { Row, Col, Collapse, Well } from "react-bootstrap";
import { DateRangePicker } from "react-dates";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";
import moment from "moment";

class InvoiceApprovalPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      open: false,
      list: true,
      preview: true,
      filteredInvoices: [],
      focusedInput: null,
      filters: localStorage.getItem("invoiceApprovalFilters")
        ? JSON.parse(localStorage.getItem("invoiceApprovalFilters"))
        : {
            account: [],
            contract: [],
            number: [],
            division: [],
            start_time: null,
            end_time: null
          }
    };

    autoBind(this);
  }

  componentDidMount() {
    let {
      accounts,
      contracts,
      users,
      items,
      chargetypes,
      divisions,
      actions
    } = this.props;

    actions.loadInvoices();
    if (isEmpty(contracts)) actions.loadContracts();
    if (isEmpty(accounts)) actions.loadAccounts();
    actions.loadUsers();
    if (isEmpty(chargetypes)) actions.loadChargetypes();
    if (isEmpty(divisions)) actions.loadDivisions();
    if (isEmpty(items)) actions.loadItems();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.invoices !== this.props.invoices) {
      let filteredInvoices = nextProps.invoices.filter(
        invoice => invoice.stage.label === "Created"
      );

      this.setState({ filteredInvoices });
    }
  }

  componentWillUnmount() {
    this.props.actions.clearInvoices();
  }

  handleChangeFilters(selectedOptions, field) {
    const filters = { ...this.state.filters };
    filters[field] = selectedOptions;
    this.setState({ filters }, () =>
      localStorage.setItem(
        "invoiceApprovalFilters",
        JSON.stringify(this.state.filters)
      )
    );
  }

  handleChangeDate = (startDate, endDate) => {
    let { filters } = this.state;
    if (startDate) {
      filters.start_time = moment(startDate).endOf("day");
      this.setState({ filters: { ...filters } }, () => {
        localStorage.setItem(
          "invoiceApprovalFilters",
          JSON.stringify(this.state.filters)
        );
      });
    }
    if (endDate) {
      filters.end_time = moment(endDate).endOf("day");
      this.setState({ filters: { ...filters } }, () => {
        localStorage.setItem(
          "invoiceApprovalFilters",
          JSON.stringify(this.state.filters)
        );
      });
    }
  };

  resetFilters() {
    this.setState({
      filters: {
        account: [],
        contract: [],
        number: [],
        division: [],
        start_time: null,
        end_time: null
      }
    });
    localStorage.removeItem("invoiceApprovalFilters");
  }

  onClickDelete(invoiceId) {
    this.props.actions.requestInvoiceId(invoiceId);
  }

  onClickPreview(invoiceId) {
    this.props.actions.getInvoice(invoiceId, true);
  }

  handleToggle(selected) {
    this.props.actions.toggleInvoice(selected);
  }

  async bulkApprove() {
    const idArray = this.props.invoicesToApprove;
    const user = this.props.auth.user;
    const stage = this.props.codes.filter(
      code => code.entity == "Invoice" && code.label === "Approved"
    );
    await this.props.actions.bulkApprove(idArray, user.id, stage[0].id);
    await this.props.actions.clearInvoices();
    await this.props.actions.loadInvoices();
  }

  genButtonText() {
    return this.props.invoicesToApprove.length > 0
      ? this.props.invoicesToApprove.length == 1
        ? ` ${this.props.invoicesToApprove.length} Invoice`
        : ` ${this.props.invoicesToApprove.length} Invoices`
      : "";
  }

  render() {
    let { invoices, InvoiceUtils } = this.props;
    const { filteredInvoices } = this.state;

    let invoiceDetails = (
      <InvoicePreview
        invoice={this.props.invoice}
        invoices={this.props.invoices}
        contracts={this.props.contracts}
        accounts={this.props.accounts}
        chargetypes={this.props.chargetypes}
        codes={this.props.codes}
        users={this.props.users}
        items={this.props.items}
        onToggle={this.handleToggle}
      />
    );

    return (
      <div className="content-wrapper">
        <Row>
          <BreadCrumbs breadcrumbs={[{ label: "Invoice Approval" }]} />
          <Col md={5} className="text-right">
            <button
              className="btn btn-success btn-sm call"
              type="button"
              onClick={() => this.setState({ open: !this.state.open })}
            >
              <FontAwesomeIcon icon={faFilter} className="icon" />
            </button>
            <button
              className="btn btn-success btn-sm btn-add"
              type="button"
              disabled={this.props.invoicesToApprove.length <= 0}
              onClick={this.bulkApprove}
            >
              {`APPROVE${this.genButtonText()}`}
            </button>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="settings-add">
            <Collapse in={this.state.open}>
              <div>
                <Well bsSize="large">
                  <Formsy ref="form" className="vertical form">
                    <Row>
                      <Col md={3} xs={12}>
                        <Select
                          isMulti
                          label="Number"
                          placeholder="Number"
                          value={this.state.filters.number}
                          onChange={newVal =>
                            this.handleChangeFilters(newVal, "number")
                          }
                          options={orderBy(
                            [
                              ...filteredInvoices.map(invoice => ({
                                value: invoice._id,
                                label: invoice.number
                              }))
                            ],
                            "label"
                          )}
                        />
                      </Col>
                      <Col md={3} xs={12}>
                        <Select
                          isMulti
                          label="Parent Account"
                          placeholder="Parent Account"
                          value={this.state.filters.account}
                          onChange={newVal =>
                            this.handleChangeFilters(newVal, "account")
                          }
                          options={orderBy(
                            [
                              ...this.props.accounts.map(account => ({
                                value: account._id,
                                label: account.name
                              }))
                            ],
                            "label"
                          )}
                        />
                      </Col>
                      <Col md={3} xs={12}>
                        <Select
                          isMulti
                          label="Contract"
                          placeholder="Contract"
                          value={this.state.filters.contract}
                          onChange={newVal =>
                            this.handleChangeFilters(newVal, "contract")
                          }
                          options={orderBy(
                            [
                              ...this.props.contracts.map(contract => ({
                                value: contract._id,
                                label: contract.name
                              }))
                            ],
                            "label"
                          )}
                        />
                      </Col>
                      <Col md={3} xs={12}>
                        <Select
                          isMulti
                          label="Divisions"
                          placeholder="Divisions"
                          value={this.state.filters.division}
                          onChange={newVal =>
                            this.handleChangeFilters(newVal, "division")
                          }
                          options={orderBy(
                            [
                              ...this.props.divisions.map(division => ({
                                value: division._id,
                                label: division.description
                              }))
                            ],
                            "label"
                          )}
                        />
                      </Col>
                      <Col md={12} xs={12}>
                        <DateRangePicker
                          startDate={
                            this.state.filters.start_time
                              ? moment.utc(this.state.filters.start_time)
                              : null
                          }
                          startDateId="startDate"
                          endDate={
                            this.state.filters.end_time
                              ? moment.utc(this.state.filters.end_time)
                              : null
                          }
                          endDateId="endDate"
                          onDatesChange={({ startDate, endDate }) => {
                            this.handleChangeDate(startDate, endDate);
                          }}
                          isOutsideRange={() => false}
                          focusedInput={this.state.focusedInput}
                          onFocusChange={focusedInput =>
                            this.setState({ focusedInput })
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="mb-0">
                      <Col md={12}>
                        <button
                          className="btn btn-warning"
                          type="button"
                          onClick={this.resetFilters}
                        >
                          Reset
                        </button>
                      </Col>
                    </Row>
                  </Formsy>
                </Well>
              </div>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {/* <pre>{JSON.stringify(this.props.invoicesToApprove, null, 2)}</pre> */}
            {this.state.list && (
              <InvoiceApprovalList
                invoices={filteredInvoices}
                filters={this.state.filters}
                onClickPreview={this.onClickPreview}
                onClearInvoices={this.props.actions.clearInvoices}
                onToggle={this.handleToggle}
                auth={this.props.auth}
                accounts={this.props.accounts}
                contracts={this.props.contracts}
              />
            )}
            <Modal
              id="invoiceDetailsModal"
              title="Invoice Preview"
              body={invoiceDetails}
              invoice={this.props.invoice}
              modal={this.props.modal}
              onClickExport={this.onClickExport}
              onToggle={this.handleToggle}
              utils={this.props.InvoiceUtils}
              close={this.props.actions.hideModal}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

InvoiceApprovalPage.propTypes = {
  auth: PropTypes.object.isRequired,
  actions: PropTypes.object,
  modal: PropTypes.object,
  invoiceToVoid: PropTypes.string,
  codes: PropTypes.array,
  invoicesToApprove: PropTypes.array,
  invoices: PropTypes.array.isRequired,
  invoice: PropTypes.object.isRequired,
  InvoiceUtils: PropTypes.object,
  contracts: PropTypes.array,
  chargetypes: PropTypes.array,
  contract: PropTypes.object,
  accounts: PropTypes.array,
  account: PropTypes.object,
  users: PropTypes.array,
  items: PropTypes.array
};

function mapStatesToProps(state, ownProps) {
  return {
    state: state.reducers,
    auth: state.reducers.auth,
    modal: state.reducers.modal,
    invoiceToVoid: state.reducers.invoiceToVoid,
    invoicesToApprove: state.reducers.invoicesToApprove,
    codes: state.reducers.codes,
    invoices: state.reducers.invoices,
    invoice: state.reducers.invoice,
    contracts: state.reducers.contracts,
    divisions: state.reducers.divisions,
    accounts: state.reducers.accounts,
    chargetypes: state.reducers.chargetypes,
    users: state.reducers.users,
    items: state.reducers.items
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...userActions,

        ...divisionActions,
        ...contractActions,
        ...chargetypeActions,
        ...accountActions,
        ...invoiceActions,
        ...userActions,
        ...itemActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(InvoiceApprovalPage);
